import { render, staticRenderFns } from "./micropaymentcom.vue?vue&type=template&id=1e9078ec&scoped=true"
import script from "./micropaymentcom.vue?vue&type=script&lang=js"
export * from "./micropaymentcom.vue?vue&type=script&lang=js"
import style0 from "./micropaymentcom.vue?vue&type=style&index=0&id=1e9078ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9078ec",
  null
  
)

export default component.exports